import { Box, Grid, Typography, useTheme } from "@mui/material"
import React from "react"

export interface PaymentInfoProps {
  data: any
}

const PaymentInfo = ({ data }: PaymentInfoProps) => {
  const theme = useTheme()
  return (
    <Grid item xs={12} p={3}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography mb={2} variant='subtitle1'>
          {" "}
          نام دارنده تسهیلات:
        </Typography>
        <Typography mb={2} variant='subtitle1'>
          {" "}
          {data?.fullName}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography mb={2} variant='subtitle1'>
          {" "}
          شماره قرارداد :
        </Typography>
        <Typography mb={2} variant='subtitle1'>
          {" "}
          {data?.contractNumber}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography mb={2} variant='subtitle1'>
          {" "}
          بدهی سر رسید شده:
        </Typography>
        <Typography mb={2} variant='subtitle1' sx={{ color: theme.palette.primary.main }}>
          {Number(data?.dueAmount).toLocaleString()} ریال
        </Typography>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography mb={2} variant='subtitle1'>
          {" "}
          مبلغ قسط:
        </Typography>
        <Typography mb={2} variant='subtitle1' sx={{ color: theme.palette.primary.main }}>
          {Number(data?.installmentAmount).toLocaleString()} ریال
        </Typography>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography mb={2} variant='subtitle1'>
          {" "}
          جمع کل بدهی:
        </Typography>
        <Typography mb={2} variant='subtitle1' sx={{ color: theme.palette.primary.main }}>
          {Number(data?.totalDebitAmount).toLocaleString()} ریال
        </Typography>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography mb={2} variant='subtitle1'>
          {" "}
          تاریخ سر رسید:
        </Typography>
        <Typography mb={2} variant='subtitle1'>
          {data?.dueDate}
        </Typography>
      </Box>
    </Grid>
  )
}

export default PaymentInfo
